import * as ActionTypes from '../../constants/actions'
import * as ListTypes from '../../constants/listTypes'

export const initialState = {
    active: false,
    listType: ListTypes.POPULARITY,
    value: '',
    type: null,
    filter: '',
    floor: null
}

export default function search(state = initialState, action) {
    let payload = action.payload;
    switch (action.type) {
        case ActionTypes.MAP_SET_POINT:
        case ActionTypes.SEARCH_HIDE:
            return {
                ...state,
                active: false,
                value: '',
                // type: '',
                filter: ''
            }
        break;

        case ActionTypes.SEARCH_SHOW:
            const nextState = {
                active: true,
                value: payload.value,
                type: payload.type,
                label: payload.label,
                floor: null
            }

            if (nextState.type !== state.type) {
                nextState.listType = ListTypes.POPULARITY
            }

            return {
                ...state,
                ...nextState
            }
        break;

        case ActionTypes.SEARCH_CHANGE_LIST_TYPE:
            return {
                ...state,
                listType: payload.type
            }
        break;

        case ActionTypes.SEARCH_CHANGE_FILTER:
            return {
                ...state,
                filter: payload.value
            }
        break;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/ui/search.js